import { render } from "./manage-stocks.vue?vue&type=template&id=491571f4&scoped=true"
import script from "./manage-stocks.vue?vue&type=script&lang=js"
export * from "./manage-stocks.vue?vue&type=script&lang=js"

import "./manage-stocks.vue?vue&type=style&index=0&id=491571f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491571f4"]])

export default __exports__